// MediaGalleryVideo
import React from 'react';
import PropTypes from 'prop-types';

const MediaGalleryVideo = ({ video, handleMediaClick }) => (
  <div id={`video-${video.id}`} className="" data-props={`Video,${video.productLineName},,,`} data-video-title={video.title} data-video-description={video.description} data-video-iframe={video.videoUrl} data-video-id={video.id}>
    <button type="button" className="gallery-modal-toggle play-video" aria-expanded={video.active} aria-label={`Show details for ${video.title}`} aria-controls={`${video.title.toLowerCase().replace(/[\s]+/g, '-')}-modal`} onClick={() => handleMediaClick(video)}>
      <div className="gallery-item-preview">
        <img className="lazy" data-src={(video.posterImage === null ? `https://i3.ytimg.com/vi/${video.id}/hqdefault.jpg` : video.posterImage)} alt={video.description} />
      </div>
      <div className="gallery-item-title" aria-hidden="true">
        <span className="icon" />
        {video.title}
      </div>
    </button>
  </div>
);

MediaGalleryVideo.propTypes = {
  handleMediaClick: PropTypes.func.isRequired,
  video: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    videoUrl: PropTypes.string,
    posterImage: PropTypes.string,
    active: PropTypes.bool,
    productLineName: PropTypes.string,
  }),
};

export default MediaGalleryVideo;
